// YH motion layer — staggered section entrances.
// Progressive enhancement only: without this file (or without JS) the page
// renders fully visible and static. Transform + opacity, reduced-motion aware.

const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

const TARGETS = [
  '.yh-home-hero__copy > *',
  '.yh-category-shortcuts',
  '.yh-editorial__copy > *',
  '.yh-editorial__figure',
  '[data-testid="product-list"] .section-resource-list__header',
  '[data-testid="product-list"] .product-card',
  '[data-testid="collection-list"] .section-resource-list__header',
  '[data-testid="collection-list"] .collection-card',
  '.section-resource-list__header',
  'main .product-card',
  '.drop-list__inner > *',
];

function revealAll() {
  for (const el of document.querySelectorAll('.yh-anim:not(.yh-in)')) el.classList.add('yh-in');
}

function start() {
  if (reduced.matches) return; // CSS keeps everything visible and still.
  document.body.classList.add('yh-motion');

  const els = [];
  for (const selector of TARGETS) {
    for (const el of document.querySelectorAll(selector)) {
      if (el.checkVisibility?.() ?? true) els.push(el);
    }
  }
  for (const el of els) el.classList.add('yh-anim');

  // Fabric's desktop squeeze layout scrolls .page-wrapper, not the document,
  // so the observer root must match the real scroll container.
  const wrapper = document.querySelector('.page-wrapper');
  const root = wrapper && wrapper.scrollHeight > wrapper.clientHeight + 100 ? wrapper : null;

  if (!('IntersectionObserver' in window)) { revealAll(); return; }

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('yh-in');
      observer.unobserve(entry.target);
    }
  }, { root, rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  for (const el of els) observer.observe(el);

  // Safety net: nothing may stay hidden, whatever happens to the observer.
  setTimeout(revealAll, 4000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
